var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99922 3.6001H26.5485L27.6735 4.7251H8.99922C8.62643 4.7251 8.32422 5.02731 8.32422 5.4001V30.6001C8.32422 30.9729 8.62643 31.2751 8.99922 31.2751H27.6742V32.4001H8.99922C8.00511 32.4001 7.19922 31.5942 7.19922 30.6001V5.4001C7.19922 4.40599 8.00511 3.6001 8.99922 3.6001ZM27.6742 31.2751V4.72581L28.7992 5.85081V31.2751H27.6742ZM25.1992 8.1001H10.7992V9.2251H25.1992V8.1001ZM10.8785 11.6107H25.2785V12.7357H10.8785V11.6107ZM18.9783 15.1239H10.8783V16.2489H18.9783V15.1239Z",
    fill: "#5B47FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f94602c2a705b36e13930d29545af390.svg";
export { ForwardRef as ReactComponent };